/*
*
* File JS per il template Work with us
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroSimple from 'components/hero-simple/hero-simple';
import breadcrumbs from 'components/breadcrumbs/breadcrumbs';

import blockTitleText from 'components/block-title-text/block-title-text';
import form from 'components/form/form';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './work-with-us.scss';

//--------------------------------------------------------------------//


// JS SPECIFICO PAGINA
//--------------------------------------------------------------------//

const manageFormJobPosition = () => {
    let allBtnJob = document.querySelectorAll('.pg-work-with-us .cta-work-item');

    if (!allBtnJob.length) return;

    let selectJob = document.getElementById('jobs-options');

    allBtnJob.forEach(el => {
        el.addEventListener('click', evt => {
            let jobValue = evt.target.dataset.job;

            if (selectJob)
            {
                selectJob.value = jobValue;
            }
        });
    });
}
manageFormJobPosition();

//--------------------------------------------------------------------//